var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLangs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_20X20_photo_Back",
    "data-name": "20X20 photo Back",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4536",
    "data-name": "Rectangle 4536",
    width: 20,
    height: 20,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_89",
    "data-name": "Mask Group 89",
    clipPath: "url(#clipPath)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "translate"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15995",
    "data-name": "Path 15995",
    d: "M17.845,8.159H10.314a2.157,2.157,0,0,0-2.155,2.155v4.092L6.208,15.8a.586.586,0,0,0,0,.954l1.975,1.411A2.158,2.158,0,0,0,10.314,20h7.531A2.157,2.157,0,0,0,20,17.845V10.314A2.157,2.157,0,0,0,17.845,8.159Zm-2.532,8.233c-.138,0-.245-.044-.276-.163l-.239-.835H13.361l-.238.835c-.031.119-.138.163-.276.163-.22,0-.515-.138-.515-.339a.362.362,0,0,1,.013-.063l1.211-3.948a.51.51,0,0,1,.521-.276c.238,0,.471.088.527.276l1.211,3.948a.278.278,0,0,1,.013.063C15.827,16.248,15.533,16.392,15.313,16.392Zm0,0",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15996",
    "data-name": "Path 15996",
    d: "M13.53,14.754h1.092l-.546-1.927Zm0,0",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15997",
    "data-name": "Path 15997",
    d: "M6.987,10.314a3.31,3.31,0,0,1,.733-2.08,3.144,3.144,0,0,1-1.8-.565,3.143,3.143,0,0,1-1.8.565.33.33,0,0,1,0-.661A2.488,2.488,0,0,0,5.4,7.218,3.152,3.152,0,0,1,4.576,5.4H4.12a.33.33,0,1,1,0-.661H5.59v-.8a.33.33,0,1,1,.661,0v.8h1.47a.33.33,0,1,1,0,.661H7.265a3.152,3.152,0,0,1-.826,1.817,2.484,2.484,0,0,0,1.282.354.33.33,0,0,1,.329.307,3.314,3.314,0,0,1,2.264-.892h1.527V5.594L13.792,4.2a.586.586,0,0,0,0-.954L11.818,1.837A2.159,2.159,0,0,0,9.686,0H2.155A2.157,2.157,0,0,0,0,2.155V9.686a2.157,2.157,0,0,0,2.155,2.155H6.987Zm0,0",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15998",
    "data-name": "Path 15998",
    d: "M5.92,6.805A2.5,2.5,0,0,0,6.6,5.4H5.242A2.5,2.5,0,0,0,5.92,6.805Zm0,0",
    fill: "#404040"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLangs);
export default __webpack_public_path__ + "static/media/Langs.c48e4ef7cc80f2ebd4ed7bae3da1f935.svg";
export { ForwardRef as ReactComponent };